import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

const inputWrapper = { height: { iphone: 50 } };

export const InputNumberFieldStyle = styled.div`
  width: 100%;

  &.rounded-shape {
    .input-element-wrapper {
      border-radius: 8px;
    }
  }

  &.circle-shape {
    .input-element-wrapper {
      border-radius: ${inputWrapper.height.iphone / 2}px;
    }
  }

  &.square-shape {
    .input-element-wrapper {
      border-radius: 0;
    }
  }

  &.error-theme,
  &.with-error {
    .input-element-wrapper {
      border: 1px solid ${colors.softRed};
      margin-bottom: 0;
    }
  }

  &.light-theme,
  &.default-theme {
    .input-element-wrapper {
      background-color: ${colors.mostlyWhite};
      border: solid 1px ${colors.mostlyWhite};

      .input-number-element {
        background-color: ${colors.mostlyWhite};
        color: ${colors.veryDarkGrayishBlue};
      }

      .input-suffix {
        color: ${colors.veryDarkGrayishBlue};
      }
    }

    .increase-value,
    .decrease-value {
      background-color: ${colors.mostlyBlack};
    }
  }

  &.dark-theme {
    .input-element-wrapper {
      background-color: ${colors.veryDarkGrayishBlue};
      border: solid 1px ${colors.veryDarkGrayishBlue};

      .input-number-element {
        background-color: ${colors.veryDarkGrayishBlue};
        color: ${colors.mostlyWhite};
      }

      .input-suffix {
        color: ${colors.mostlyWhite};
      }

      .increase-value,
      .decrease-value {
        background-color: ${colors.mostlyBlack};

        svg {
          fill: ${colors.white};
        }
      }
    }
  }

  .input-element-wrapper {
    overflow: hidden;
    padding: 12px 48px 14px 20px;
    position: relative;
    width: 100%;

    .input-number-element {
      ${fontFamily?.sourceSansPro?.regular};
      background: transparent;
      border: none;
      display: inline-block;
      font-size: 14px;
      line-height: 20px;
      margin: 0;
      padding: 0;
      text-align: right;
    }

    .increase-value,
    .decrease-value {
      align-items: center;
      background-color: ${colors.mostlyBlack};
      display: flex;
      height: 24px;
      justify-content: center;
      position: absolute;
      right: 0;
      width: 28px;

      svg {
        display: block;
        height: auto;
        width: 10px;
      }
    }

    .increase-value {
      top: 0;
      width: 28px;
    }

    .decrease-value {
      bottom: 0;
      width: 28px;

      svg {
        transform: rotate(180deg);
      }
    }
  }

  .input-error {
    ${fontFamily?.sourceSansPro?.regular};
    background: transparent;
    border: none;
    color: ${colors.softRed};
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
`;
